var useContentfulMedia = function (media) {
    var _a, _b;
    var videoFields = (_b = (_a = media === null || media === void 0 ? void 0 : media.fields) === null || _a === void 0 ? void 0 : _a.imageOrVideo) === null || _b === void 0 ? void 0 : _b.fields;
    return {
        videoFields: videoFields,
    };
};

export { useContentfulMedia };
//# sourceMappingURL=useContentfulMedia.esm.js.map
